import { CellTypes, GridColDef } from '@fashionnovateam/nova-ui-toolkit';

export type ItemRequestRow = {
  id: string;
  checkbox?: CellTypes.DataGridCellCustomParams;
  photo: CellTypes.DataGridCellPhotoParams;
  product: CellTypes.DataGridCellCustomParams;
  'last_message.updated_at': CellTypes.DataGridCellCustomParams;
  requested_for: CellTypes.DataGridCellCustomParams;
  requested_date: CellTypes.DataGridCellDateTimeParams;
  cost_jr: CellTypes.DataGridCellCustomParams;
  cost_plus: CellTypes.DataGridCellCustomParams;
  baseline_cost_jr?: CellTypes.DataGridCellCustomParams;
  baseline_cost_plus?: CellTypes.DataGridCellCustomParams;
  country_of_origin: CellTypes.DataGridCellCustomParams;
  earliest_custom_cut_delivery_date: CellTypes.DataGridCellCustomParams;
  custom_cut_lead_time_in_weeks: CellTypes.DataGridCellCustomParams;
  shipment_mode: CellTypes.DataGridCellCustomParams;
  exclusivity: CellTypes.DataGridCellCustomParams;
  stock_quantity: CellTypes.DataGridCellCustomParams;
  stock_ratio: CellTypes.DataGridCellCustomParams;
  earliest_IHD_date_to_deliver_stock: CellTypes.DataGridCellCustomParams;
  incoming_stock_quantity: CellTypes.DataGridCellCustomParams;
  incoming_stock_ratio: CellTypes.DataGridCellCustomParams;
  incoming_stock_date: CellTypes.DataGridCellCustomParams;
  custom_MOQ_jr: CellTypes.DataGridCellCustomParams;
  custom_MOQ_plus: CellTypes.DataGridCellCustomParams;
  comments: CellTypes.DataGridCellCustomParams;
  submit: CellTypes.DataGridCellCustomParams;
};

export const requiredColumns: GridColDef[] = [
  {
    field: 'photo',
    headerName: 'Photo',
    render: 'photo',
    sortable: false,
    minWidth: 60,
    width: 60,
  },
  {
    field: 'product',
    headerName: 'Product',
    render: 'custom',
    sortable: false,
    minWidth: 240,
    width: 240,
  },
  {
    field: 'last_message.updated_at',
    headerName: 'Latest Message',
    render: 'custom',
    sortable: false,
    minWidth: 240,
    width: 240,
  },
  {
    field: 'requested_for',
    headerName: 'Requested For',
    render: 'custom',
    sortable: false,
    minWidth: 170,
    width: 170,
  },
  {
    field: 'cost_jr',
    headerName: 'JR Cost',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'cost_plus',
    headerName: 'Plus Cost',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'country_of_origin',
    headerName: 'Country of Origin',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'earliest_custom_cut_delivery_date',
    headerName: 'Delivery Date',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 180,
    width: 180,
  },
  {
    field: 'custom_cut_lead_time_in_weeks',
    headerName: 'Lead Time',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'shipment_mode',
    headerName: 'Shipment Mode',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'exclusivity',
    headerName: 'FN Exclusive',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
];

export const baselineCostColumns: GridColDef[] = [
  {
    field: 'baseline_cost_jr',
    headerName: 'Baseline JR Cost',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 170,
    width: 170,
  },
  {
    field: 'baseline_cost_plus',
    headerName: 'Baseline Plus Cost',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 170,
    width: 170,
  },
];

export const optionalColumns: GridColDef[] = [
  {
    field: 'stock_quantity',
    headerName: 'Stock Qty',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'stock_ratio',
    headerName: 'Stock Ratio',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'earliest_IHD_date_to_deliver_stock',
    headerName: 'Stock IHD',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'incoming_stock_quantity',
    headerName: 'Incoming Stock Qty',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'incoming_stock_ratio',
    headerName: 'Incoming Stock Ratio',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'incoming_stock_date',
    headerName: 'Incoming Stock IHD',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'custom_MOQ_jr',
    headerName: 'JR MOQ',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'custom_MOQ_plus',
    headerName: 'Plus MOQ',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
  {
    field: 'comments',
    headerName: 'Comments',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 410,
    width: 410,
  },
];

export const checkboxColumn: GridColDef = {
  field: 'checkbox',
  headerName: '',
  render: 'custom',
  sortable: false,
  disableColumnMenu: true,
  minWidth: 50,
  width: 50,
};

export const actionColumn: GridColDef = {
  field: 'submit',
  headerName: '',
  render: 'custom',
  sortable: false,
  minWidth: 140,
  width: 140,
};

export const requestedDateColumn: GridColDef = {
  field: 'requested_date',
  headerName: 'Requested Date',
  render: 'dateTime',
  sortable: true,
  minWidth: 155,
  width: 155,
};

export const completedExtraColumns: GridColDef[] = [
  requestedDateColumn,
  {
    field: 'updated_at',
    headerName: 'Last Updated',
    render: 'custom',
    sortable: false,
    minWidth: 155,
    width: 155,
  },
];
